import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { authService } from '@/services/authService';
import { Mail, X, Loader2 } from 'lucide-react';

export function EmailVerificationBanner() {
  const { isAuthenticated, user } = useAuthStore();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);
  const [error, setError] = useState('');

  if (!isAuthenticated || !user || user.emailVerified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setResending(true);
    setError('');
    try {
      await authService.resendVerificationEmail();
      setResent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to resend');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="bg-amber-50 dark:bg-amber-950/30 border-b border-amber-200 dark:border-amber-800 px-4 py-2">
      <div className="flex items-center justify-between gap-2 max-w-7xl mx-auto">
        <div className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-200">
          <Mail className="h-4 w-4 flex-shrink-0" />
          <span>
            Please verify your email address.
            {resent ? (
              <span className="ml-1 font-medium">Verification email sent!</span>
            ) : error ? (
              <span className="ml-1 text-red-600 dark:text-red-400">{error}</span>
            ) : (
              <button
                onClick={handleResend}
                disabled={resending}
                className="ml-1 font-medium underline hover:no-underline disabled:opacity-50"
              >
                {resending ? (
                  <Loader2 className="h-3 w-3 inline animate-spin" />
                ) : (
                  'Resend verification email'
                )}
              </button>
            )}
          </span>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
